module.exports = __webpack_public_path__ + "static/media/28.bcad29e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/28.png
// module id = 810
// module chunks = 0